/**
 * Self-hosted role-guide URLs (Fredrik, 2026-09-01). The pages live in
 * frontend/public/guides/ and are served by the app itself, so external
 * reviewers reach them without any claude.ai access. One constant per
 * placement target — switching a guide to a different host later is a
 * one-line change here.
 */
export const ROLE_GUIDES = {
  producer: '/guides/producer-guide.html',
  producerFiles: '/guides/producer-guide.html#files',
  producerComments: '/guides/producer-guide.html#comments',
  reviewer: '/guides/reviewer-guide.html',
  decisionMaker: '/guides/decision-maker-guide.html'
} as const;
